'use client';

import React, { HTMLAttributes } from 'react';

import Image from 'next/image';

interface IArrowScrollProps extends HTMLAttributes<HTMLDivElement> {
  headerHeight?: number;
  navigateToId: string | number;
}

export const ArrowScroll: React.FC<IArrowScrollProps> = ({
  navigateToId,
  headerHeight = 0,
}) => {
  const scrollTo = (sectionId: string | number) => {
    const section = document.getElementById(`section-${sectionId}`);
    const body = document.body;

    if (section) {
      window.scrollTo({
        top:
          section.getBoundingClientRect().top -
          body.getBoundingClientRect().top -
          headerHeight,
      });
    }
  };

  return (
    <button
      onClick={() => scrollTo(navigateToId)}
      className="absolute bottom-[30px] left-1/2 -translate-x-1/2 transition hover:translate-y-1 hover:opacity-80 hidden desktop:block">
      <Image
        src={
          'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/scroll-down.png'
        }
        alt="arrow-down"
        width={16}
        height={33}
      />
    </button>
  );
};
